export default class TechnicalBackgroundInfo {

  private readonly _value: string;

  constructor(value: string) {
    this._value = value;
  }
  public get value(): string {
    return this._value;
  }
  public static fromJSON(value: string): TechnicalBackgroundInfo | undefined {
    if (!value || value === '') return;
    return new TechnicalBackgroundInfo(value);
  }

  public toJSON(): string {
    return this._value;
  }
}
